import { render, staticRenderFns } from "./levy-finance.vue?vue&type=template&id=384210b3&scoped=true"
import script from "./levy-finance.vue?vue&type=script&lang=ts"
export * from "./levy-finance.vue?vue&type=script&lang=ts"
import style0 from "./levy-finance.vue?vue&type=style&index=0&id=384210b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384210b3",
  null
  
)

export default component.exports